import {
  menu_default
} from "../../chunks/chunk.4KSSK4CB.js";
import "../../chunks/chunk.UHA22HSA.js";
import "../../chunks/chunk.VVA35HTY.js";
import "../../chunks/chunk.TUVJKY7S.js";
import "../../chunks/chunk.EVP45OG4.js";
import "../../chunks/chunk.KAW7D32O.js";
export {
  menu_default as default
};
